import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'outsourceController';
export default {
    /**
     * 新增/修改委外方管理
     */
    createOutsource: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'createOutsource',
        type: requestType.Post
    },
    /**
     * 删除委外方
     */
    deleteOutsource: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'deleteOutsource',
        type: requestType.Delete
    },
    /**
     * 统计委托方信息的 案件信息
     */
    getAllOutSourceInfoByCase: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllOutSourceInfoByCase',
        type: requestType.Get
    },
    /**
     * 查询委外方
     */
    query: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'query',
        type: requestType.Get
    },
    /**
     * 委外方下拉列表 (所有的委外方都可以调用)
     */
    getOutsourceList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getOutsourceList',
        type: requestType.Get
    },
};
